// Sprint #40: rota do admin de Agentes IA (Settings)
import { frontendURL } from '../../../../helper/URLHelper';

const AgentsIaIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents-ia'),
      name: 'settings_agents_ia_index',
      component: AgentsIaIndex,
      meta: { permissions: ['administrator'] },
    },
  ],
};
